export default function validateForm({name, email, subject, message}) {
    console.log(`In validateForm name=${name} email=${email} subject=${subject} message=${message}`);

    if (!name.trim()) {
        return 'Name is required';
    }
    // else if (!/^[A-Za-z]+/.test(name.trim())) {
    //   errors.name = 'Enter a valid name';
    // }

    const regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (!email) {
        return 'Email is required';
    } else if (regex.test(email.toLocalLowerCase)) {
        return 'Email address is invalid';
    }

    if (!subject) {
        return 'Subject is required';
    }

    if (!message) {
        return 'Message is required';
    }

    return null;
}